import { render, staticRenderFns } from "./CustomerDetailComponent.vue?vue&type=template&id=76ef7024"
import script from "./CustomerDetailComponent.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports